/**
 * Auth-specific error shapes.
 *
 * Some auth endpoints report failure inside a 200 response instead of using an
 * HTTP error status, so the service layer converts those bodies into rejections
 * that look like Axios errors and therefore flow through `getApiErrorMessage`.
 */
import { ERROR_MESSAGES, HTTP_STATUS } from '../../constants';
import type { ApiError } from '../../types';

export interface InvalidOtpError extends ApiError {
  isInvalidOtp: true;
}

export const createInvalidOtpError = (message?: string): InvalidOtpError => ({
  isInvalidOtp: true,
  response: {
    status: HTTP_STATUS.BAD_REQUEST,
    data: { message: message || ERROR_MESSAGES.INVALID_OTP },
  },
});

export const isInvalidOtpError = (error: unknown): error is InvalidOtpError =>
  typeof error === 'object' &&
  error !== null &&
  (error as { isInvalidOtp?: boolean }).isInvalidOtp === true;
